export default __webpack_public_path__ + "static/media/5.465196b0.png";